// styles
import {
    HeaderWidgetContainer
} from './HeaderWidget.styles';

export default function HeaderWidget({ children, fullWidth = false }) {
  return (
    <HeaderWidgetContainer className='widget-bg' $fullWidth={fullWidth}>
        { children }
    </HeaderWidgetContainer>
  )
}
